import React from "react";
import LeftDrawer from "../NavBar/LeftDrawer";
import Appbar from "../NavBar/Appbar";
import MyCarousel from "../CarouselElements/MyCarousel";
import AccordianTree from '../NavBar/SelectDialog/AccordianTree.js';
import BackButton from '../NavBar/BackButton';
import SendDialog from '../NavBar/SendDialog';
import SelectDialog from '../NavBar/SelectDialog/';
import BetterTabs from '../NavBar/SelectDialog/BetterTabs.js';
import { Radio } from 'antd';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import './pillcards.css';
import EditDialog from '../NavBar/EditDialog';


const RadioButton = Radio.Button;
const RadioGroup = Radio.Group;
class PatientView extends React.Component {
  //True for switch means Classes
  constructor(props) {
    super(props);
    let priceTypes = ["prices"];
    if (this.props.va) {
      priceTypes.push("va_formulary");
    } else {
      priceTypes.push("medicaid");
    }
    let treatTypes = ["fda", "offlabel"];
    this.handleLanguage = this.handleLanguage.bind(this);
    this.handleCost = this.handleCost.bind(this);
    this.handleTreat = this.handleTreat.bind(this);
    this.handleSideEffects = this.handleSideEffects.bind(this);
    this.state = {
      //whether to show preferred and ruled out drug classes
      designatedHandler: this.handler,
      switchOption: false,
      language: "eng",
      costTypes: priceTypes,
      currCostTypeIndex: 1,
      currSideEffectIndex: 0,
      currTreatTypeIndex: 0,
      treatTypes: treatTypes,
      //whether we are va or not
      va: this.props.va,
      pillcardsobj: []
    };
  }

  handleSideEffects() {
    this.setState({ currSideEffectIndex: this.state.currSideEffectIndex ^ 1 });
  }

  handleCost() {
    this.setState({ currCostTypeIndex: this.state.currCostTypeIndex ^ 1 });
  }

  handleTreat() {
    this.setState({ currTreatTypeIndex: this.state.currTreatTypeIndex ^ 1 });
  }

  componentWillMount() {
    var that = this;
    fetch(`https://api.medbase.xyz${this.props.location.pathname}`)
      .then(function(response) {
        if (response.status >= 400) {
          throw new Error("Bad response from server");
        }
        return response.json();
      })
      .then(function(data) {
        that.setState({ pillcardsobj: data });
        that.setState({ isLoading: false });
      });
  }
  handleLanguage(language) {
    this.setState({ language: language.target.value });
  }

  selectedCards() {
    var cards = [];
    for (var i = 0; i < this.state.pillcardsobj.length; i++) {
      cards.push(this.state.pillcardsobj[i][0]);
    }
    return cards;
  }

  render() {
    let { isLoading, va } = this.state;
    let { type } = this.props;
    if (!isLoading) {
      return (
        <div className="page-div">
            <div classsName="buttons-div-2">
              {/*
              <LeftDrawer
                type={type}
                va={va}
                switchOption={this.state.switchOption}
                handleSwitch={this.handleSwitch}
                language={this.state.language}
                handleLanguage={this.handleLanguage}
                cost={this.state.costTypes}
                costIndex={this.state.currCostTypeIndex}
                treatTypes={this.state.treatTypes}
                treatsIndex={this.state.currTreatTypeIndex}
                handleTreat={this.handleTreat}
                handleCost={this.handleCost}
              />
              */}
              <ListItem style={{"width":"auto"}}>
              <RadioGroup defaultValue={this.state.language} onChange={this.handleLanguage} size="large">
              <RadioButton value="eng">English</RadioButton>
              <RadioButton value="es">Spanish</RadioButton>
              </RadioGroup>
            </ListItem>
            </div>
            <BackButton />
            <div />
          <MyCarousel
            type={this.props.type}
            cards={this.state.pillcardsobj}
            language={this.state.language}
            cost={this.state.costTypes}
            costIndex={this.state.currCostTypeIndex}
            seIndex={this.state.currSideEffectIndex}
            toggleTreatsHandler={this.handleTreat}
            toggleCostHandler={this.handleCost}
            toggleSideEffectHandler={this.handleSideEffects}
            treatTypes={this.state.treatTypes}
            treatsIndex={this.state.currTreatTypeIndex}
            switchOption={this.state.switchOption}
          />
        </div>
      );
    }
    return "Loading...please wait";
  }
}

export default PatientView;



// WEBPACK FOOTER //
// ./src/Pillcards/PatientView.js